module.exports = __webpack_public_path__ + "static/androidBannerCarParts-9fc4a519decbc5b8c1bd93533522c44b.png";